export default __webpack_public_path__ + "static/media/s1.07d7441e.jpg";